import React, { useState, useEffect } from "react";
import ReviewAssessBoxHW from "./ReviewAssessBoxHW";
import axios from "../../../../axios";
import NoResponse from "../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import moment from "moment";

let helper;
const ReviewAssePropsBoxHW = ({ filter }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [publishhw, setPublishHW] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const timeHelper = (a) => {
    const outputDateString = moment(a).format("DD/MM/YYYY");
    return outputDateString;
  };
  useEffect(() => {
    const getPublishedRes = async () => {
      try {
        let helper = [];
        let response = await axios.get(
          `/api/v1/homework/filterByTeacherId/${Teacher_Json}/review?_page=1&academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data?.data?.length === 0) {
          helper = [];
          setPublishHW([]);
          setNoresponse(true);
        }
        response?.data?.data.forEach((obj) => {
          let res = {
            id: obj?.id,
            section: `${obj?.section_id?.name}`,
            standard: `${obj?.standard_id?.name}`,
            published_subject: `${obj?.subject_id.name}`,
            published_assessName: `${obj?.name}`,
            deadline_date: timeHelper(obj?.deadline),
            Published_response: "91",
          };
          helper.push(res);
          setPublishHW(helper);
        });
      } catch (e) {
        console.log(e);
      } finally {
        setIsGettingData(false);
      }
    };
    getPublishedRes();
  }, [filter]);

  return publishhw && publishhw.length > 0 ? (
    <>
      <div className="container">
        <div className="row">
          {publishhw.map((obj) => (
            <div key={obj.id} className="col-md-3 d-flex mb-3">
              <ReviewAssessBoxHW
                Homework_id={`${obj.id}`}
                section={`${obj?.section}`}
                standard={`${obj?.standard}`}
                Review_subject={`${obj.published_subject}`}
                Review_assessName={`${obj.published_assessName}`}
                deadline_date={`${obj.deadline_date}`}
                Review_response="91"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  ) : // (
  //   <>
  //     <img
  //       className="publishAccessLoader"
  //       src="/gift/black loader.gif"
  //       alt=""
  //     />
  //     {noresponse && <NoResponse setNoresponse={setNoresponse} />}
  //   </>
  // );
  isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="px-2 py-2 d-flex align-items-center gap-2"
        style={{ fontSize: "1.2rem", fontWeight: 500 }}
      >
        ✏️ Homework Not Found
      </span>
    </div>
  );
};

export default ReviewAssePropsBoxHW;
